var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneVerification = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 72,
  height: 72,
  viewBox: "0 0 72 72",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 72,
  fill: "#FFF",
  rx: 36
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(24, 24)",
  fill: "none",
  stroke: "#3b82f6",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.6 13.3l-1.3 1.6a12.6 12.6 0 0 1-5.2-5.2l1.6-1.3c.42-.34.53-.94.26-1.4L9.1 3.9a1.06 1.06 0 0 0-1.28-.47l-3 1.1A1.1 1.1 0 0 0 4.1 5.7C4.6 12.9 11.1 19.4 18.3 19.9c.5.04.96-.27 1.13-.73l1.1-3a1.06 1.06 0 0 0-.47-1.28l-3.1-1.85c-.46-.27-1.06-.16-1.4.26Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.2 3.2a7 7 0 0 1 6.6 6.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.9 6.9a3.6 3.6 0 0 1 3.2 3.2"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneVerification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone_verification.970d056a24c501d872492b0d0016375b.svg";